/** @format */
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ModelSearchResultsType } from '@toucan/common/services/search/constants';
import { getModelSearchResults } from '@toucan/common/services/search/model/helpers';
import {
    ModelSearchResultsSearchParams,
    Query,
} from '@toucan/common/services/search/types';

import { Milliseconds } from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';

import { useShouldUseSemanticSearch } from '@toucan/client/features/search/components/model-search-results/hooks/use-should-use-semantic-search';

export const useModelPaginatedResults = (
    queryKey: string,
    isInfiniteScroll: boolean,
    resultsPerPage: number,
    baseQuery: Partial<Query>,
    searchParams: ModelSearchResultsSearchParams,
    type: ModelSearchResultsType
) => {
    const { activeMarket } = useContext(MarketContext);
    const shouldUseSemanticSearch = useShouldUseSemanticSearch(type);

    const pageIndex = searchParams.pageIndex;
    const start = pageIndex * resultsPerPage;
    const rows = resultsPerPage;

    // eslint-disable-next-line @tanstack/query/exhaustive-deps -- Legacy code: do not use as an example.
    return useQuery({
        enabled: !isInfiniteScroll,
        queryKey: ['modelSearchResults', type, queryKey],
        queryFn: async () => {
            const results = await getModelSearchResults(
                baseQuery,
                searchParams,
                start,
                rows,
                activeMarket,
                { type, shouldUseSemanticSearch }
            );

            return results;
        },
        refetchOnWindowFocus: false,
        staleTime: Milliseconds.FIVE_MINUTES,
    });
};
